export enum ReportKeys {
  SMS_SEND = 'sms_send',
  BULK_SMS = 'bulk_sms',
  SCHEDULED_FILES = 'scheduled_files',
  EMG_SEND_REPORT = 'emg_send_report',
}
